import React, { useState, useEffect } from "react";
import { apiClient } from "../../../services/api/apiClient";
import AddPipeFittingModal from "../Pipes/AddPipeFittingModal";

function AddSpacingModal({
  isOpen,
  onClose,
  trade,
  submittalId,
  onSuccess,
  editData,
}) {
  const [formData, setFormData] = useState({
    material: "",
    maxSize: "",
    rodSize: "",
    spacing: "",
    notes: "",
  });
  const [allSizes, setAllSizes] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [isAddProductModalOpen, setIsAddProductModalOpen] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [sizesResponse, materialsResponse] = await Promise.all([
          apiClient.get("/sizes"),
          apiClient.get("/materials")
        ]);

        // setAllSizes(sizesResponse);
        // setMaterials(materialsResponse)
        // this will change once we update materials
        setAllSizes(sizesResponse?.data || []);
        setMaterials(materialsResponse?.data || []);
      } catch (error) {
        console.error("Error fetching data:", error);
        // Set empty arrays as fallback to prevent undefined errors
        setAllSizes([]);
        setMaterials([]);
      }
    };

    fetchData();
  }, []);

  // Populate form when editData is provided
  useEffect(() => {
    if (editData && materials.length > 0 && allSizes.length > 0) {
      console.log("Setting spacing form data for edit:", editData);
      setFormData({
        material: editData.material || "",
        maxSize: editData.max_size || "",
        rodSize: editData.rod_size || "",
        spacing: editData.spacing || "",
        notes: editData.notes || "",
      });
    } else if (!editData) {
      // Reset form for new entries
      setFormData({
        material: "",
        maxSize: "",
        rodSize: "",
        spacing: "",
        notes: "",
      });
    }
  }, [editData, isOpen, materials, allSizes]);

  if (!isOpen) return null;

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate that submittalId is provided
    if (!submittalId) {
      alert("Error: No submittal ID provided. Cannot save spacing.");
      console.error("submittalId is missing:", submittalId);
      return;
    }

    console.log("Submitting spacing with submittalId:", submittalId);

    try {
      const result = editData 
        ? await apiClient.put(`/hangers/spacing/${editData.id}`, {
            pvfsubmittal_id: submittalId,
            material: formData.material,
            max_size: formData.maxSize,
            rod_size: formData.rodSize,
            spacing: formData.spacing,
            notes: formData.notes,
            trade: trade,
          })
        : await apiClient.post("/hangers/spacing", {
            pvfsubmittal_id: submittalId,
            material: formData.material,
            max_size: formData.maxSize,
            rod_size: formData.rodSize,
            spacing: formData.spacing,
            notes: formData.notes,
            trade: trade,
          });

              const responseData = result.data;
        
        if (result && result.success) {
        console.log(
          `Spacing ${editData ? "updated" : "saved"} successfully:`,
          responseData
        );
        // Close modal and reset form
        onClose();
        setFormData({
          material: "",
          maxSize: "",
          rodSize: "",
          spacing: "",
          notes: "",
        });
        // Call onSuccess callback to refresh the parent component
        if (onSuccess) {
          onSuccess();
        }
      } else {
        console.error(
          `Error ${editData ? "updating" : "saving"} spacing:`,
          result
        );
        alert(
          `Error ${editData ? "updating" : "saving"} spacing: ` + result
        );
      }
    } catch (error) {
      console.error("Error submitting spacing data:", error);
      alert("Error submitting spacing data. Please try again.");
    }
  };

  const openAddProductModal = () => {
    setIsAddProductModalOpen(true);
  };

  const closeAddProductModal = () => {
    setIsAddProductModalOpen(false);
    // Future: Add product refresh logic here if needed
  };

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-[51]">
      <div className="bg-white p-6 rounded-2xl shadow-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-bold text-gray-900">
            {editData ? "Edit Spacing" : "Add Spacing"}
          </h2>
          <div className="flex items-center space-x-3">
            <button
              type="button"
              onClick={openAddProductModal}
              className="px-2 py-1 text-xs font-medium text-green-600 border border-green-600 rounded hover:bg-green-50"
            >
              Add Product
            </button>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
            >
              ×
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Material
            </label>
            <select
              name="material"
              value={formData.material}
              onChange={handleInputChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
            >
              <option value="">Select Material</option>
              {Array.isArray(materials) && materials.map((material) => (
                <option key={material.id} value={material.name}>
                  {material.name}
                </option>
              ))}
            </select>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Max Size
              </label>
              <select
                name="maxSize"
                value={formData.maxSize}
                onChange={handleInputChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
              >
                <option value="">Select Size</option>
                {Array.isArray(allSizes) && allSizes.map((size) => (
                  <option key={size.id} value={size.size}>
                    {size.size}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Rod Size
              </label>
              <select
                name="rodSize"
                value={formData.rodSize}
                onChange={handleInputChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
              >
                <option value="">Select Rod Size</option>
                {Array.isArray(allSizes) && allSizes.map((size) => (
                  <option key={size.id} value={size.size}>
                    {size.size}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Spacing
            </label>
            <input
              type="text"
              name="spacing"
              value={formData.spacing}
              onChange={handleInputChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
              placeholder="Enter spacing"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Notes
            </label>
            <textarea
              name="notes"
              value={formData.notes}
              onChange={handleInputChange}
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
              placeholder="Enter notes"
            />
          </div>

          <div className="flex justify-end space-x-3 mt-6">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-700"
            >
              {editData ? "Update Spacing" : "Add Spacing"}
            </button>
          </div>
        </form>
      </div>

      {/* Add Product Modal - Ready for future product fields */}
              <AddPipeFittingModal
          isOpen={isAddProductModalOpen}
          onClose={closeAddProductModal}
        />
    </div>
  );
}

export default AddSpacingModal;
